<template>
    <div :ref="stepName" style="position:relative">
<!--        <div class="form-header">-->
<!--            <p>Pagamento tramite conto corrente bancario:</p>-->
<!--            <p><span>Prova Altroconsumo GRATIS per 15&nbsp;giorni + dopo la prova solo 2€ per i primi 2 mesi</span></p>-->
<!--        </div>-->
        <IbanForm></IbanForm>

        <div class="iban-cancellation">
            <div>
                <img src="/images/icons/happy_emoji.svg" alt="happy emoji">
                <p>Je résilie à tout moment et sans frais</p>
            </div>
            <p>
                Testachats met un point d’honneur à offrir à ses membres une flexibilité maximale. Ainsi, si vous estimez que l’abonnement ne correspond pas à vos attentes, vous avez la liberté de résilier votre abonnement à tout moment, sans frais. En cas de résiliation, vous n’aurez plus accès aux nombreux avantages réservés aux membres, mais vous aurez pu tester l’ensemble des services pendant plusieurs mois. Vous conservez également votre cadeau de bienvenue (sous réserve qu'il ait déjà été commandé sur la plateforme Giftin) et vous ne serez plus redevable d’aucune somme supplémentaire à Testachats.
            </p>
        </div>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import IbanForm from "./IbanForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { IbanForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
